<div class="card-container">
  <app-tour-card *ngFor="let tour of galleryTours; trackBy: trackById" [tour]="tour"
    [distance]="tour | distance:currentPosition">
  </app-tour-card>

  <app-tour-card *ngFor="let item of [].constructor(galleryTours.length ? 0 : count)">
  </app-tour-card>
</div>
